import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Modal } from 'AppSrc/core/components/utility/modal';
import { CrossSvg } from 'AppSrc/core/components/common/svg-icons';
import 'AppSrc/core/style/components/form/form-base-components/v-f-modal.css';
import 'AppSrc/core/style/components/form/form-base-components/sub-components/tip-modal.css';


const TipModal = React.memo(({
  tip,
  name,
}) => {
  const [modalOpen, setModalOpen] = useState(false);
  const modalData = {
    option: null,
    alertTitle: tip.title,
    Content: tip.Content,
    showFalse: false,
    showTrue: true,
    trueText: 'Close',
    Icon: CrossSvg,
  };
  const className = `tip-modal tip-modal-${name}`;
  const resolveAlert = () => {
    setModalOpen(false);
  };

  const Icon = tip.icon;


  return (
    <div className={className}>
      <div className="svg-wrapper-container">
        <div className="svg-wrapper">
          <button
            type="button"
            onClick={() => setModalOpen(true)}
          >
            <Icon />
          </button>
        </div>
      </div>
      {
        modalOpen && (
          <Modal
            alertData={modalData}
            resolveAlert={resolveAlert}
          />
        )
      }
    </div>
  );
});
TipModal.propTypes = {
  tip: PropTypes.shape({
    icon: PropTypes.elementType,
    title: PropTypes.string,
    Content: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.elementType,
    ]),
  }),
  name: PropTypes.string,
};


export { TipModal };
